import ActivityCard from './ActivityCardContainer'

export default ActivityCard